import { FC } from 'react';

import { Comment } from 'src/api/comments';
import { CommentItem } from '../CommentItem';
import styles from '../CommentItem.module.scss';

interface CommentRepliesProps {
  showReplies: boolean;
  localReplies: Comment[];
  toggleReplies: () => void;
  postId: string;
  onDelete: (commentId: string) => void;
  onEdit: (commentId: string, newText: string) => void;
}

export const CommentReplies: FC<CommentRepliesProps> = ({
  showReplies,
  localReplies,
  toggleReplies,
  postId,
  onDelete,
  onEdit,
}) => (
  <>
    <div className={styles.replies}>
      {localReplies.map((reply) => (
        <CommentItem
          key={reply._id}
          comment={reply}
          replies={[]}
          postId={postId}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </div>
  </>
);
